import request from '@/utils/request'

/**
 * 登录
 * @param {*} data 
 */
export function logIn(data) {
  return request({
    url: '/Account/Login',
    method: 'post',
    data
  })
}

//自动绑定OpenId
export function logInBindOpenId(data) {
  return request({
    url: '/Account/AutomaticBindOpenId',
    method: 'post',
    params: { OpenId : data}
  })
}

// /**
//  * 自动登录
//  * @param {*} data 
//  */
// export function autoLogin(data) {
//   return request({
//     url: '/Account/AutoLogin',
//     method: 'post',
//     data
//   })
// }


// WEBPACK FOOTER //
// ./src/api/account/account.js